import { fwEndpointStatusColors, fwEndpointStatusLabels } from './constants';

const UNKNOWN = 'unknown';
export const NOT_RECORDED = 'nie zapisano';

const present = value => value !== null && value !== undefined && value !== '';

/**
 * The board label for a backend status code. A code this build does not know
 * reads as the explicit unknown state, never as a raw server token.
 */
export const endpointStatusLabel = code => fwEndpointStatusLabels[code] ?? fwEndpointStatusLabels[UNKNOWN];

export const endpointStatusColor = code => fwEndpointStatusColors[code] ?? fwEndpointStatusColors[UNKNOWN];

/** The diagnostic tooltip: the stored failure code and phase, or nothing. */
export const statusTooltip = row => {
    if (!row || !present(row.failure_code)) return null;

    return present(row.failure_phase) ? `${row.failure_code} (${row.failure_phase})` : row.failure_code;
};

const routeParts = route => {
    if (!route || typeof route !== 'object') return [];
    const parts = [];
    if (present(route.mode)) parts.push(String(route.mode));
    if (present(route.apn)) parts.push(String(route.apn));
    if (present(route.ip)) parts.push(present(route.port) ? `${route.ip}:${route.port}` : String(route.ip));

    return parts;
};

export const formatRoute = route => routeParts(route).join(' · ');

/**
 * A board payload is used only for the task that was requested and only when
 * every row carries a status code; anything else is a read failure.
 */
export const validBoardPayload = (data, taskId) => {
    if (!data || typeof data !== 'object') return false;
    if (String(data.task_id) !== String(taskId)) return false;
    if (!Array.isArray(data.endpoints)) return false;

    return data.endpoints.every(row => row && typeof row === 'object' && typeof row.status === 'string');
};

const validList = list => Boolean(list) && typeof list === 'object' && Array.isArray(list.rows);

export const validActivityPayload = (data, sign) => {
    if (!data || typeof data !== 'object') return false;
    if (data.sign !== sign) return false;

    return validList(data.active) && validList(data.pickup);
};

const valueOrMarker = value => (present(value) ? value : NOT_RECORDED);

export const boardRow = row => ({
    ...row,
    label: endpointStatusLabel(row?.status),
    color: endpointStatusColor(row?.status),
    tooltip: statusTooltip(row),
    routeText: formatRoute(row?.route) || NOT_RECORDED,
    signText: valueOrMarker(row?.sign),
    sourceText: valueOrMarker(row?.source_revision),
    targetText: valueOrMarker(row?.target_revision),
    pickupText: valueOrMarker(row?.command_pickup_count),
    connectionText: valueOrMarker(row?.connection_count),
});
